import React, { useState, useEffect } from 'react'
import Helmet from 'react-helmet'
import { Link } from 'gatsby'

import { ExternalLinkIcon } from '../assets/ExternalLinkIcon'
import { StarIcon } from '../assets/StarIcon'
import { Hero } from '../components/Hero'
import { Layout } from '../components/Layout'
import { PageLayout } from '../components/PageLayout'
import { SEO } from '../components/SEO'
import config from '../utils/config'
import { projects } from '../../content/data/projects'

export default function Projects() {
  const [repos, setRepos] = useState([])
  const title = 'Projects'
  const description = "Amazing projects I've developed over the years."

  useEffect(() => {
    async function getStars() {
      const repos = await fetch('https://api.github.com/users/fyvri/repos')

      return repos.json()
    }

    getStars()
      .then((data) => {
        setRepos(data)
      })
      .catch((err) => console.error(err))
  }, [])

  return (
    <>
      <Helmet title={`${title} | ${config.title}`} />
      <SEO postPath="/projects" customDescription={description} />

      <PageLayout>
        <Hero title={title} description={description} />

        <div className="cards">
          {projects.map((project) => {
            const repo = repos.find((repo) => repo.name === project.slug)
            return (
              <div className="card" key={project.slug}>
                {repo && repo.stargazers_count > 0 && (
                  <div className="stars">
                    <div className="star">
                      <a
                        href={`https://github.com/fyvri/${project.slug}/stargazers`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {Number(repo.stargazers_count).toLocaleString()}
                      </a>
                      <StarIcon />
                    </div>
                  </div>
                )}
                <time>{project.date}</time>
                {repo ? (
                  <a
                    className="card-header"
                    href={`https://github.com/fyvri/${project.slug}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {project.name}
                  </a>
                ) : (
                  <span className="card-header">{project.name}</span>
                )}
                <p className="small">{project.tagline}</p>
                <div className="card-links">
                  {project.writeup && (
                    <Link className="button small" to={project.writeup}>
                      Article
                    </Link>
                  )}
                  {project.url && (
                    <a
                      className="button small"
                      href={project.url}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Demo <ExternalLinkIcon />
                    </a>
                  )}
                  {project.docs && (
                    <a
                      className="button small"
                      href={project.docs}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Docs <ExternalLinkIcon />
                    </a>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      </PageLayout>
    </>
  )
}

Projects.Layout = Layout
